import { AppserverCredentials } from "./appserver-credentials.model";

export interface IAppserverCredentialsRepository {
    hent(): AppserverCredentials;
}
